import { AxiosResponse } from 'axios';
import { authenticatedPostRequest } from './authenticatedRequestService';
import envConfig from '../config/environment-config';

async function verifyPharmaceutical(login: string): Promise<AxiosResponse<any, any>> {
  const method = 'pharmaceuticals/registeredPharmaceutical';
  const body = {
    crf: login.split('-')[0],
    uf: login.split('-')[1],
    programCode: envConfig.boehringerProgramCode,
  };
  
  return await authenticatedPostRequest(
    method,
    body,
  );
}

async function loginPharmaceutical(login: string, password: string): Promise<AxiosResponse<any, any>> {
  const method = 'auth/login';
  const body = {
    login,
    password,
    programId: envConfig.boehringerProgramCode,
  };

  return await authenticatedPostRequest(
    method,
    body,
  );
}

export default {
  verifyPharmaceutical,
  loginPharmaceutical,
};
